<main class="min-h-screen w-full bg-neutral-100">

  <!-- Mobile backdrop -->
  @if (isSidebarOpen()) {
    <div class="fixed inset-0 z-40 bg-black/40 lg:hidden" (click)="toggleSidebar()"></div>
  }

  <crm-sidebar [isOpen]="isSidebarOpen()" (toggle)="toggleSidebar()" />

  <!-- Mobile-only open button (shown when sidebar is fully hidden) -->
  <button type="button"
          class="fixed top-3 left-3 z-[60] w-9 h-9 flex items-center justify-center rounded-lg bg-neutral-0 border border-neutral-300 shadow-sm hover:bg-neutral-100 transition-colors lg:hidden"
          [class.hidden]="isSidebarOpen()"
          (click)="toggleSidebar()">
    <span inlineSVG="assets/icons/menu.svg" class="custom-icon" style="--width: 18px; --color: #6F94A3"></span>
  </button>

  <div class="layout-content" [class.layout-content--expanded]="isSidebarOpen()">
    <router-outlet />
  </div>

  <crm-footer [sidebarOpen]="isSidebarOpen()" />
</main>
